import type { AxiosResponse } from "axios";
import { createMutation } from "react-query-kit";

import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, queryClient } from "@/api";
import { getApi } from "@api/apiPath";
import type { IMspDto } from "@api/msp/types";
import { useGetAllMedicalServiceCenter } from "@api/msp/getAll";

const { getPath } = getApi("msp.post");

type IVariables = IMspDto;
type IResponse = AxiosResponse<IApiResponse<unknown>>;

export const postMsp: IAxiosFn<IVariables, IResponse> = (data, signal) => {
  return axiosClient.post(getPath(), data, { signal });
};

export const usePostMsp = createMutation({
  mutationFn: (data: IVariables) => postMsp(data),
  onSuccess: (_data, _variables) => {
    queryClient.invalidateQueries(useGetAllMedicalServiceCenter.getKey());
  },
});
